import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import FontAwesome from 'react-fontawesome';

import AccountMenu from './AccountMenu';
import Button from '../../components/Button';
import PaymentApi from '../../payments';
import Api from '../../Api';
import LightBox from '../../components/LightBox';
import {  CreditCardPayment, NetNinetyPayment } from '../checkout/PaymentInformation';

import './payments.less';

export default class Payments extends React.Component {
  constructor(props) {
    super(props);

    Api.Utils.bindThis(
      this,
      [
        'showModal',
        'hideModal',
        'actionLinkBankAccount',
        'actionLinkCreditCard'
      ]
    );

    this.state = {
      modalVisible: false,
      user: Api.cache.getUser()
    };
  }

  componentWillMount() {
    Api.userStartListen(this, 'user');
  }

  componentWillUnmount() {
    Api.userStopListen(this);
  }

  showModal() {
    this.setState({ modalVisible: true });
  }

  hideModal() {
    this.setState({ modalVisible: false });
  }

  actionLinkBankAccount(event) {
    event.preventDefault();
    let returnValue = PaymentApi.addBankAccount(this.state.user);

    returnValue.then(this.hideModal);

    return returnValue;
  }

  actionLinkCreditCard(event) {
    event.preventDefault();
    let returnValue = PaymentApi.addCreditCard(this.state.user);

    returnValue.then(this.hideModal);

    return(returnValue);
  }

  render() {
    if (!this.state.user) return null;

    let instruments = (this.state.user.instruments || []).map(
      (instrument, idx) => {
        return <PaymentEntry key={instrument.token} instrument={instrument} default={idx === 0} />;
      }
    );

    return (
      <div className="payments-component">
        <div className="header">
          <Button onClick={this.showModal} className="fixed-right">Add Payment Method</Button>
          <h1>Manage Payment Methods</h1>
        </div>
        <AccountMenu className={this.state.orderListLoading ? 'hidden' : ''}>
          <li className="active">Payment Methods</li>
        </AccountMenu>
        <div className="payment-methods">
          {instruments}
        </div>
        <LightBox onClose={this.hideModal} className={'payments-modal' + (this.state.modalVisible ? '' : ' hidden')}>
          <div><h2>Select a Payment Method</h2></div>
          <div className="row">
            <NetNinetyPayment title="ADD BANK ACCOUNT" buttonText="LINK ACCOUNT" onClick={this.actionLinkBankAccount} />
            <CreditCardPayment title="ADD CREDIT CARD" buttonText="LINK CARD" onClick={this.actionLinkCreditCard} />
          </div>
        </LightBox>
      </div>
    );
  }
}

class PaymentEntry extends React.Component {
  static propTypes = {
    instrument: PropTypes.object.isRequired,
    "default": PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.flag = this.flag.bind(this);
    this.cardInfo = this.cardInfo.bind(this);
    this.expiration = this.expiration.bind(this);
    this.setDefault = this.setDefault.bind(this);
    this.removeInstrument = this.removeInstrument.bind(this);
  }

  flag() {
    let flag = null;

    if (this.props.instrument.card) {
      flag = this.props.instrument.card.brand;
    }
    if (this.props.instrument.bank_account) {
      flag = this.props.instrument.bank_account.institution;
    }

    switch (flag) {
      case 'VISA':
      case 'MASTERCARD':
      case 'AMEX':
      case 'PAYPAL':
        return <FontAwesome name={`cc-${flag.toLowerCase()}`} />;
      default:
    }

    return flag;
  }

  cardInfo() {
    if (this.props.instrument.card) {
      return `**** **** **** ${this.props.instrument.card.last_four}`;
    }
    if (this.props.instrument.bank_account) {
      return this.props.instrument.bank_account.account_number;
    }

    return null;
  }

  expiration() {
    if (!this.props.instrument.card || !this.props.instrument.card.expiration) return null;
    return `${this.props.instrument.card.expiration.month}/${this.props.instrument.card.expiration.year}`;
  }

  setDefault(event) {
    event.preventDefault();
    console.log('setDefault');
    return Api.setDefaultInstrument(this.props.instrument.token);
  }

  removeInstrument(event) {
    event.preventDefault();

    let alertText = 'Are you sure you want to remove payment ' + this.cardInfo();
    if (!confirm(alertText)) return;

    console.log('remove instrument');

    return Api
      .removeInstrument(this.props.instrument.token)
      .then(() => {
        return Api.getUser()
      });
  }

  render() {
    let defaultOption = 'Default';
    if (!this.props.default) {
      defaultOption = <Button onClick={this.setDefault}>Set as Default</Button>;
    }

    return (
      <div className="payment-entry">
        <div className="flag">{this.flag()}</div>
        <div className="card-info">
          <div className="number">{this.cardInfo()}</div>
          <div className="expiration">{this.expiration()}</div>
        </div>
        <div className="default">{defaultOption}</div>
        <div className="delete">
          <Link className={'remove' + (this.props.default ? ' hidden' : '')} onClick={this.removeInstrument}>Remove</Link>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/user/payments.js
 **/